import React from 'react';
import './Projects.css';

const Project = ({ projects }) => {
    

    return projects.map (project => {
        return (
            <div className="project" key={project.title}>
                <div className = "image-container">
                    <img src={project.preview} alt = "Project Preview" />
                    <p className = "type">{project.language}</p>
                    <p className = "title">{project.title}</p>
                </div>
                <div className = "description-and-links">
                    <p className = "description">{project.desc}</p>
                    <div className = "links">
                        <a href={project.git} target="_blank" rel="noreferrer">Code</a>
                        <a href = {project.demo} target = "_blank" rel="noreferrer">Demo</a>
                    </div>
                </div>

            </div>
        );
    });
};

export default Project;